import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

const initialState = {
  selectedLoansForDSCR: [],
  dscrReportComponent: null,
  dscrCalculations: null,
  totalDscrValue: null
};

export const SET_DSCR_SETUP_SELECTIONS = generateDefaultActions("SET_DSCR_SETUP_SELECTIONS");
export const setDscrSetupSelections = payload => makeWritePayload(SET_DSCR_SETUP_SELECTIONS.value, payload);

export const SET_DSCR_SETUP_TO_DEFAULT = generateDefaultActions("SET_DSCR_SETUP_TO_DEFAULT");
export const setDscrSetupToDefault = () => makeWritePayload(SET_DSCR_SETUP_TO_DEFAULT.value, initialState);

export const SET_CALCULATION_CONTEXT_TO_PROJECTED = generateDefaultActions("SET_CALCULATION_CONTEXT_TO_PROJECTED");
export const setCalculationContextToProjected = () => makeWritePayload(SET_CALCULATION_CONTEXT_TO_PROJECTED.value, initialState);

export const actionCreators = {
  setDscrSetupSelections,
  setDscrSetupToDefault,
  setCalculationContextToProjected
};


export const lenderReportsDscrSetupReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DSCR_SETUP_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DSCR_SETUP_TO_DEFAULT.value:
      return defaultReturn({ ...payload });

    case SET_CALCULATION_CONTEXT_TO_PROJECTED.value:
      return defaultReturn({ ...state, isProjected: true });
    default:
      return state;
  }
};
